import { ColDef } from '@ag-grid-community/core'

const ApplicationListColDefs: ColDef[] = [
  {
    field: 'companyName',
  },
  {
    field: 'name',
  },
  {
    field: 'carrier',
  },
  {
    field: 'benefitEffectiveDate',
  },
  {
    field: 'commissionPartner',
  },
  {
    field: 'status',
  },
  {
    field: 'benefitId',
  },
]

export default ApplicationListColDefs
